import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import { getDefaultState } from './defaultState'
import { getters } from './getters'
import { mutations } from './mutations'
import { actions } from './actions'

Vue.use(Vuex)

export default new Vuex.Store({
  state: getDefaultState(),
  getters: getters(),
  mutations: mutations(),
  actions: actions(),
  plugins: [createPersistedState({
    key: 'sto-jalousie-konfigurator',
    paths: ['calculatorData.currentOrder']
  })]
})
